import React from 'react';
import { Link } from '../../atoms/Link';
import './MainNavItem.css';

export interface MainNavItemProps {
  label: string;
  href: string;
  badgeText?: string;
  badgeColor?: string;
  isActive?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const MainNavItem: React.FC<MainNavItemProps> = ({
  label,
  href,
  badgeText,
  badgeColor,
  isActive = false,
  onMouseEnter,
  onMouseLeave,
  className = '',
  style,
}) => {
  return (
    <div
      className={`hi-ui hi-ui-mainnav-item ${isActive ? 'active' : ''} ${className}`.trim()}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {badgeText && (
        <div className="hi-ui-mainnav-item__sale-badge">
          <span className="hi-ui-nav-badge" style={{ backgroundColor: badgeColor }}>
            {badgeText}
          </span>
        </div>
      )}
      <Link href={href} noUnderline className="hi-ui-mainnav-item__link">
        {label}
      </Link>
      <div className="hi-ui-mainnav-item__underline" />
    </div>
  );
};
